import { createReducer } from '@reduxjs/toolkit';

import { CONTRACT_AUTHENTICATION_INITIALIZE } from '@app/store/actionTypes';
import { fetchContractAuthentication } from '@app/store/contract-authentication/actions';

type ContractAuthenticationSequencesState = string[] | null;

const initialState: ContractAuthenticationSequencesState = null;

const reducer = createReducer<ContractAuthenticationSequencesState>(initialState, (builder) =>
  builder
    .addCase(CONTRACT_AUTHENTICATION_INITIALIZE, () => initialState)
    .addCase(fetchContractAuthentication.pending, () => [])
    .addCase(fetchContractAuthentication.fulfilled, (state, action) => {
      const { digitalCertificate, mobile, password } = action.payload.authentication;

      if (!state) {
        // eslint-disable-next-line no-param-reassign
        state = [];
      }

      if (password) {
        state.push(password.authenticationId);
      }

      if (mobile) {
        state.push(mobile.authenticationId);
      }

      if (digitalCertificate) {
        state.push(digitalCertificate.authenticationId);
      }
    })
);

export default reducer;
